import React from 'react';
import Appearance from 'styles/Appearance.js';
import Utils from 'files/Utils.js';

const MobileApp = () => {

    const features = [
        'Remote management & monitoring from anywhere',
        'Real-time data from every sensor',
        'Event-driven push alerts, the instant they fire',
        'No subscription, no monitoring fees',
    ];

    const onAppStoreClick = () => {
        window.open('https://apps.apple.com/us/app/aqua-link-connect/id6800409079');
    }

    const onPlayStoreClick = () => {
        window.open('https://play.google.com/store/apps/details?id=com.ghs.omnishield.dealership965.android');
    }

    const storeBadge = (icon, top, bottom) => (
        <div 
        onClick={icon.includes('apple') ? onAppStoreClick : onPlayStoreClick}
        style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 12,
            padding: '12px 22px',
            borderRadius: 12,
            backgroundColor: Appearance.colors.dark(),
            cursor: 'pointer',
        }}>
            <i className={icon} style={{ fontSize: 26, color: Appearance.colors.white }} />
            <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.1 }}>
                <span style={{
                    fontFamily: Appearance.fonts.body,
                    fontSize: 10,
                    color: 'rgba(255,255,255,0.7)',
                }}>
                    {top}
                </span>
                <span style={{
                    fontFamily: Appearance.fonts.body,
                    fontWeight: 700,
                    fontSize: 16,
                    color: Appearance.colors.white,
                }}>
                    {bottom}
                </span>
            </div>
        </div>
    );

    const headerBlock = (
        <div>
            <span style={{
                ...Appearance.textStyles.label(),
                marginBottom: 14,
                display: 'block',
            }}>
                {'Aqua Link Connect App'}
            </span>
            <h2 style={{
                ...Appearance.textStyles.sectionHeading({ textAlign: 'left' }),
                marginBottom: Utils.isMobile() ? 0 : 16,
                textWrap: 'balance',
            }}>
                {'Your whole system, in your pocket'}
            </h2>
        </div>
    );

    const bodyBlock = (
        <div>
            <p style={{
                ...Appearance.textStyles.body(),
                marginBottom: 28,
                maxWidth: 480,
            }}>
                {'Available free on iOS and Android, the Aqua Link Connect app puts every sensor at your fingertips — remote management and monitoring, live data, and event-driven alerts for your entire home. No subscription, no hidden fees.'}
            </p>

            {/* Feature highlights */}
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 16,
                marginBottom: 32,
            }}>
                {features.map((feature, index) => (
                    <div key={index} style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 12,
                    }}>
                        <i className={'fas fa-check-circle'} style={{
                            fontSize: 18,
                            color: Appearance.colors.primary(),
                        }} />
                        <span style={Appearance.textStyles.body({ color: Appearance.colors.text(), fontWeight: 500 })}>
                            {feature}
                        </span>
                    </div>
                ))}
            </div>

            {/* Store badges */}
            <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
                {storeBadge('fab fa-apple', 'Download on the', 'App Store')}
                {storeBadge('fab fa-google-play', 'Get it on', 'Google Play')}
            </div>
        </div>
    );

    const contentSection = (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
        }}>
            {headerBlock}
            {bodyBlock}
        </div>
    );

    const phoneSection = (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
        }}>
            {/* Soft glow */}
            <div style={{
                display: 'none',
                position: 'absolute',
                width: Utils.isMobile() ? 300 : 420,
                height: Utils.isMobile() ? 300 : 420,
                borderRadius: '50%',
                background: `radial-gradient(circle, ${Utils.hexToRGBA(Appearance.colors.primary(), 0.14)} 0%, rgba(255,255,255,0) 70%)`,
                pointerEvents: 'none',
            }} />

            {/* Phone frame */}
            <img 
            src={'/images/mobile-app-ios.png'}
            style={{
                width: 280,
                height: 560,
                position: 'relative'
            }} />
        </div>
    );

    return (
        <section id={'app'} style={{
            width: '100%',
            backgroundColor: Appearance.colors.offWhite,
        }}>
            <div style={{
                maxWidth: Appearance.layout.maxWidth,
                margin: '0 auto',
                padding: Appearance.layout.sectionPadding(),
                display: 'grid',
                gridTemplateColumns: Utils.isMobile() ? '1fr' : '1fr 1fr',
                gap: Utils.isMobile() ? 32 : 80,
                alignItems: 'center',
            }}>
                {Utils.isMobile() ? (
                    <>
                        {headerBlock}
                        {phoneSection}
                        {bodyBlock}
                    </>
                ) : (
                    <>
                        {phoneSection}
                        {contentSection}
                    </>
                )}
            </div>
        </section>
    );
};

export default MobileApp;
